import { useEffect, useState } from 'react'
import { readToken } from './api'

/**
 * Whether the visitor holds a main-site login token. Lab does not decode or
 * verify it; apiserver decides on every request whether it is still valid.
 */
export function useSignedIn(): boolean {
  const [signedIn, setSignedIn] = useState(() => Boolean(readToken()))
  useEffect(() => {
    const sync = () => setSignedIn(Boolean(readToken()))
    window.addEventListener('storage', sync)
    window.addEventListener('lab:unauthorized', sync)
    window.addEventListener('focus', sync)
    return () => {
      window.removeEventListener('storage', sync)
      window.removeEventListener('lab:unauthorized', sync)
      window.removeEventListener('focus', sync)
    }
  }, [])
  return signedIn
}
